import React from 'react';
import { Badge } from '@cargomatic/ui';
import { humanize } from 'underscore.string';
import { SHIPPER, CARRIER } from 'constants/UserTypes';

export const CustomerTypeBadge = ({ customerType }) => {
  if (!customerType) return null;

  let color = 'gray';
  if (customerType.toLowerCase() === SHIPPER) color = 'green';
  if (customerType.toLowerCase() === CARRIER) color = 'blue';

  return <Badge color={color}>{humanize(customerType)}</Badge>;
};
